module.exports = __webpack_public_path__ + "media/assets/images/blog/clienti_scontenti-a8044ebc236c64bbfc8ee9c0f5c45647.jpeg";